import axios from 'axios';
import { getSession } from 'libs/sessionStorage';
import { apiUrl, generalApiUrl } from 'dictionaries/Env';
import { sayGoodbye } from 'helpers/Users';

const createClientInstance = url => {
  const defaultOptions = {
    baseURL: url,
    headers: {
      'Content-Type': 'application/json'
    }
  };

  // Create instance
  let instance = axios.create(defaultOptions);

  // Set the AUTH token for any request
  instance.interceptors.request.use(function(config) {
    const user = getSession('user');
    config.headers.Authorization = user.token ? `Bearer ${user.token}` : '';
    return config;
  });

  // 503 http status handler
  instance.interceptors.response.use(
    function(response) {
      return response;
    },
    function(error) {
      if (error.response && error.response.status === 503) {
        return sayGoodbye();
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export const restClient = createClientInstance(apiUrl);
export const restClientGeneral = createClientInstance(generalApiUrl);



// WEBPACK FOOTER //
// ./src/libs/restClient.js